<template>
  <div class="swiper logo-cloud-swiper" ref="swiperEl">
    <div class="swiper-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Swiper, { Autoplay, FreeMode } from 'swiper';
import 'swiper/css';

export default {
  name: 'LogoCloudSlider',
  mounted() {
    this.swiper = new Swiper(this.$refs.swiperEl, {
      modules: [Autoplay, FreeMode],
      slidesPerView: 'auto',
      spaceBetween: 24,
      loop: true,
      freeMode: true,
      speed: 4000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    });
  },
  beforeUnmount() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  },
};
</script>

<style>
.logo-cloud-swiper .swiper-wrapper {
  transition-timing-function: linear !important;
}
</style>